import moment from 'moment';

import { StoreInvitation } from '@funnels/types';

export default function getLatestInvitation(invitations: StoreInvitation[], applicantId?: string) {
  let expiresOn = 0;
  return invitations.reduce((acc: StoreInvitation, i: StoreInvitation) => {
    if (!(i.applicantId === applicantId)) {
      return acc;
    }
    const currentExpiresOn = moment(i.expiresOn || 0).valueOf();
    if (!expiresOn || expiresOn <= currentExpiresOn) {
      expiresOn = currentExpiresOn;
      return i;
    }
    return acc;
  }, {} as StoreInvitation);
}
